function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useContext, useRef, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, EmptySearch, PropertiesTree, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useKeypress } from '@keen.io/react-hooks';
import { Container, DropdownContent } from './FilterProperty.styles';
import PropertyGroup, { PropertyItem } from '../../../PropertyGroup';
import Property from '../../../Property';
import PropertyTypeCast from '../PropertyTypeCast';
import { SearchContext, AppContext } from '../../../../contexts';

var FilterProperty = function FilterProperty(_ref) {
  var property = _ref.property,
      type = _ref.type,
      properties = _ref.properties,
      onBlur = _ref.onBlur,
      onSelectProperty = _ref.onSelectProperty,
      onCastPropertyType = _ref.onCastPropertyType,
      onSearchProperties = _ref.onSearchProperties;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var containerRef = useRef(null);

  var _useContext = useContext(SearchContext),
      expandTree = _useContext.expandTree,
      searchPropertiesPhrase = _useContext.searchPropertiesPhrase;

  var _useContext2 = useContext(AppContext),
      modalContainer = _useContext2.modalContainer;

  var isEmptySearch = searchPropertiesPhrase && properties && !Object.keys(properties).length;
  var outsideClick = useCallback(function (e) {
    if (editMode && containerRef.current && !containerRef.current.contains(e.target)) {
      setEditMode(false);
      onBlur();
    }
  }, [editMode, containerRef]);
  useEffect(function () {
    if (!property) setEditMode(true);
  }, []);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [editMode, containerRef]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    if (keyCode === KEYBOARD_KEYS.ESCAPE) {
      setEditMode(false);
      onBlur();
    }
  }, []);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ESCAPE],
    addEventListenerCondition: editMode,
    eventListenerDependencies: [editMode]
  });
  return React.createElement(Container, {
    ref: containerRef,
    onClick: function onClick() {
      return !editMode && setEditMode(true);
    },
    onKeyDown: function onKeyDown(e) {
      return e.keyCode === KEYBOARD_KEYS.ENTER && !editMode && setEditMode(true);
    },
    "data-testid": "filter-property",
    role: "button",
    tabIndex: 0
  }, React.createElement(PropertyGroup, {
    isActive: editMode
  }, React.createElement(PropertyItem, null, React.createElement(Property, {
    property: property,
    editMode: editMode,
    placeholder: t('query_creator_filter_property.placeholder'),
    searchPlaceholder: t('query_creator_filter_property.search_placeholder'),
    onEditInputChange: onSearchProperties
  })), property && !editMode && React.createElement(PropertyTypeCast, {
    property: property,
    type: type,
    onChange: onCastPropertyType
  })), React.createElement(Dropdown, {
    isOpen: editMode,
    fullWidth: false
  }, React.createElement(DropdownContent, null, isEmptySearch ? React.createElement(EmptySearch, {
    message: t('query_creator_filter_property.empty_search_results')
  }) : React.createElement(PropertiesTree, {
    modalContainer: modalContainer,
    expanded: expandTree,
    activeProperty: property,
    properties: properties,
    onClick: function onClick(_e, property) {
      onSelectProperty(property);
      setEditMode(false);
    }
  }))));
};

export default FilterProperty;